import values from 'mout/object/values'
import contains from 'mout/array/contains'
import forOwn from 'mout/object/forOwn'

export default function getByPassageType(subtest, scores) {
  function findActivePassageType(passageNumber, c, d, r) {
    if (contains(c, passageNumber.toString())) {
      return 'Conflicting Viewpoints'
    } else if (contains(d, passageNumber.toString())) {
      return 'Data Representations'
    } else if (contains(r, passageNumber.toString())) {
      return 'Research Summaries'
    } else return null
  }

  function getPassageItemIndexes(subtest) {
    const readingPassages = [
      {name: 'Literary Narrative', items: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]},
      {name: 'Social Science', items: [10, 11, 12, 13, 14, 15, 16, 17, 18, 19]},
      {name: 'Humanities', items: [20, 21, 22, 23, 24, 25, 26, 27, 28, 29]},
      {name: 'Natural Science', items: [30, 31, 32, 33, 34, 35, 36, 37, 38, 39]},
    ]
    if (subtest.displayName === 'Reading') {
      return readingPassages
    } else if (subtest.displayName !== 'Science') {
      return null
    } else {
      const { sectionBreaks, 
              conflictingViewpointsPassages, 
              dataRepresentationPassages, 
              researchSummaryPassages } = subtest
      const c = conflictingViewpointsPassages,
            d = dataRepresentationPassages,
            r = researchSummaryPassages
      let items = {
        'Conflicting Viewpoints': [],
        'Data Representations': [],
        'Research Summaries': [],
      }
      let activePassageType
      for (let i = 0; i < 40; i++) {
        if (contains(sectionBreaks, (i + 1).toString())) {
          const passageNumber = sectionBreaks.indexOf((i + 1).toString()) + 1
          activePassageType = findActivePassageType(passageNumber, c, d, r)
        }
        if (activePassageType) items[activePassageType].push(i)
      }
      let sciencePassages = []
      forOwn(items, (items, name) => {
        sciencePassages.push({name, items})
      })
      return sciencePassages
    }
  }

  function sortByIndex(items) {
    return items.sort((a, b) => {
      const numA = parseInt(a.index, 10)
      const numB = parseInt(b.index, 10)
      if (numA < numB) {
        return -1
      } else if (numA > numB) {
        return 1
      } else return 0
    }) 
  }

  function averagePercent(items) {
    let possible = 0, raw = 0
    items.forEach((item) => {
      possible += parseInt(item.possible, 10)
      raw += parseInt(item.raw, 10) 
    })
    if (possible) {
      return raw / possible
    } else return 0
  }

  function percentByPassageType(subtest, scores) {
    const subtestId = subtest.setId
    const passageItemIndexes = getPassageItemIndexes(subtest)
    const byItem = sortByIndex(values(scores.byItem[subtestId]))
    const passageItems = passageItemIndexes.map(function replaceIndexesWithItems(passage) {
      const items = passage.items.map((itemIndex) => byItem[itemIndex])
      const percent = averagePercent(items)
      return {
        name: passage.name,
        percent,
      }
    })
    return passageItems
  }
 
  return percentByPassageType(subtest, scores)

}


/*

*/


// WEBPACK FOOTER //
// ./src/helpers/assessment/getByPassageType.js